export interface TaskDoubleTableAnimationReady {
    animationReady: TaskDoubleTableAnimationStatus
}
export type TaskDoubleTableAnimationStatus = 0 | 1 | 2
export const taskDoubleTableAnimationKeys: { [key: string]: TaskDoubleTableAnimationStatus } = {
    'none': 0,
    'loading': 1,
    'loaded': 2
}